import { useMemo } from 'react';
import {
  AttachMoneyRounded as AttachMoneyRoundedIcon,
  Percent as PercentIcon,
} from '@mui/icons-material';
import { Input, InputBaseProps } from './Input';
import { Typography } from '../typography';

interface InputPriceProps extends InputBaseProps {
  isPercent?: boolean;
}

export const InputPrice: React.FC<InputPriceProps> = ({
  onInput,
  onChange,
  isPercent,
  endIcon = <AttachMoneyRoundedIcon />,
  ...props
}: InputPriceProps) => {
  const inputEndIcon = useMemo(() => {
    if (isPercent) return <PercentIcon />;

    if (typeof endIcon === 'string') return <Typography variant={'textM'}>{endIcon}</Typography>;

    return endIcon;
  }, [endIcon, isPercent]);

  const handleOnInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = e.target.value
      .replace(/[^0-9.]/g, '')
      .replace(/\.{2,}/g, '.')
      .replace(/(\..*?)\./g, '$1');

    if (onInput) onInput(e);
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const clonedEvent = {
      ...e,
      target: {
        ...e.target,
        value: Number(e.target.value).toFixed(2),
      },
    };

    if (onChange) onChange(clonedEvent);
  };

  return (
    <Input onInput={handleOnInput} onChange={handleOnChange} endIcon={inputEndIcon} {...props} />
  );
};
